import { defineStore } from "pinia";
import { reactive, ref } from "vue";
import { FeedbackService } from "@/App/services/FeedbackService";
import { useTrackedState } from "@/App/components/patient/composables/useTrackedState";
import type { TrackedState } from "@/App/components/patient/types/TrackedState";

export const useFeedbackStore = defineStore("feedback", () => {
  const show = ref(false);

  const toggle = (): void => {
    show.value = !show.value;
  };

  const close = (): void => {
    show.value = false;
  };

  const open = (): void => {
    show.value = true;
  };

  const createFeedbackState = reactive({}) as TrackedState<object>;

  const save = useTrackedState<object>({
    state: createFeedbackState,
    fn: async (feedback) => {
      return await FeedbackService.addFeedback(feedback as string);
    },
    onFulfilled(): void {
      return close();
    },
    onRejected: (reason) => {
      return ["Failed to add feedback", reason as string];
    },
  });

  return {
    createFeedbackState,
    show,
    toggle,
    close,
    save,
    open,
  };
});
